/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistCosoRequisitoDTO} from './ChecklistCosoRequisitoDTO';

/**
 * The ChecklistCosoPrincipioDTO model module.
 * @module model/ChecklistCosoPrincipioDTO
 * @version v0
 */
export class ChecklistCosoPrincipioDTO {
  /**
   * Constructs a new <code>ChecklistCosoPrincipioDTO</code>.
   * @alias module:model/ChecklistCosoPrincipioDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistCosoPrincipioDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistCosoPrincipioDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistCosoPrincipioDTO} The populated <code>ChecklistCosoPrincipioDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistCosoPrincipioDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('checklistCosoRequisiti'))
        obj.checklistCosoRequisiti = ApiClient.convertToType(data['checklistCosoRequisiti'], [ChecklistCosoRequisitoDTO]);
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistCosoPrincipioDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
ChecklistCosoPrincipioDTO.prototype.position = undefined;

/**
 * @member {String} title
 */
ChecklistCosoPrincipioDTO.prototype.title = undefined;

/**
 * @member {Array.<module:model/ChecklistCosoRequisitoDTO>} checklistCosoRequisiti
 */
ChecklistCosoPrincipioDTO.prototype.checklistCosoRequisiti = undefined;

/**
 * @member {String} tooltip
 */
ChecklistCosoPrincipioDTO.prototype.tooltip = undefined;

